import { Component, OnInit,Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
//import {ConfirmationDialogComponent} from '../confirmation-dialog/confirmation-dialog.component';
import { DigitalsignatureDialogComponent } from '../digitalsignature-dialog/digitalsignature-dialog.component';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css']
})
export class ConfirmationDialogComponent implements OnInit {
  
  disableApply = false;
  disableSubmit = true;
  partnername;
  partnerid;
  lastInserted;

  constructor(public dialog: MatDialog,
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { 

      //console.log(data);
      this.partnername = data.partnername;
      this.partnerid = data.partnerid;
  }

  ngOnInit() {

  }

  /* openSubmit(){
    
    this.dialogRef.close(this.lastInserted);

  } */

  openDialog() {
    this.dialog.openDialogs.pop();
    const dialogRef = this.dialog.open(DigitalsignatureDialogComponent, {
      height: '560px',
      width: '950px',
      data: { partnername: this.partnername,partnerid:this.partnerid }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log(result);
        this.lastInserted = result;
        this.disableApply = true;
        this.disableSubmit = false;
        this.dialogRef.close(this.lastInserted);
      }
    });
  }

}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/profile/confirmation-dialog/confirmation-dialog.component.ts